module.exports = __webpack_public_path__ + "img/top_image_pie.010a638a.png";